import './ga4';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.addEventListener('load', function() {
    //
    // scroll tout en haut de la page lors de l'ouverture du menu
    //
    const open = document.querySelector('.hamburger.hamburger-open');

    if (open) {
        open.addEventListener('click', () => {
            window.scrollTo({
                behavior: 'smooth',
                top: 0,
            });
        });
    }

    //
    // fermeture du menu lors du redimensionnement de la fenêtre
    //
    const offcanvasEl = document.getElementById('menu');

    if (offcanvasEl) {
        function onResize() {
            Offcanvas.getInstance(offcanvasEl)?.hide();
        }

        offcanvasEl.addEventListener('show.bs.offcanvas', () => {
            window.addEventListener('resize', onResize);
        });

        offcanvasEl.addEventListener('hide.bs.offcanvas', () => {
            window.removeEventListener('resize', onResize);
        });
    }


    //
    // animation des compteurs lors de l'apparition dans la fenêtre
    //
    const counters = document.querySelectorAll('.counter');

    function animateCounter(counter, target, duration = 1000) {
        const startTime = performance.now();

        function animate(currentTime) {
            const progress = Math.min((currentTime - startTime) / duration, 1);

            counter.textContent = Math.round(target * progress);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        counter.textContent = '0';
        requestAnimationFrame(animate);
    }

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            const counter = entry.target;
            const target = parseInt(counter.dataset.target, 10);

            animateCounter(counter, target);

            observer.unobserve(counter);
        });
    }, {
        threshold: 0.5,
    });

    counters.forEach((counter) => {
        observer.observe(counter);
    });
});
